export default "https://ssr-releases-cdn.paperlesspost.com/_next/static/video/AppPromo_Mobile-00ce6980d6bedc288f17a867269351a9.png";